import React, { useState } from 'react';
import Helmet from 'react-helmet';
import ReactDOM from 'react-dom';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import AdminLayout from '../../../Shared/AdminLayout';
import ProfileCard from '../../../Shared/ProfileCard';
import DataCard from '../../../Shared/DataCard';
import DataContainer from '../../../Shared/DataContainer';
import Icon from '../../../Shared/Icon';
import classNames from 'classnames';
import TextInput from '../../../Shared/TextInput';
import LoadingButton from '../../../Shared/LoadingButton';
import * as moment from 'moment';
import axios from 'axios';

function AssingProduct() {
     const { auth, errors, data } = usePage().props;
     const [sending, setSending] = useState(false);
     const [values, setValues] = useState({
          prods: data.products,
          search: '',
          searchResult: [],
          products: [],
          selectedProducts: []
     });

     const iconClasses = classNames('w-4 h-4 mr-2', {
          'text-white fill-current': false,
          'text-gray-500 hover:text-white fill-current': true
     });

     const iconClassesTrash = classNames('w-4 h-4', {
          'text-white fill-current': false,
          'text-red-500 hover:text-white fill-current': true
     });

     function handleChange(e) {
          const key = e.target.name;
          const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
          setValues(values => ({
               ...values,
               [key]: value
          }));
     }

     function handleAdd(id, i) {
          let searchResult = values.searchResult;
          searchResult[i].isCheck = !searchResult[i].isCheck;
          let selected = Object.assign({}, searchResult[i]);
          let products = values.products;
          let selectedProducts = values.selectedProducts;
          products.push(selected.id);
          selectedProducts.push(selected);
          searchResult.splice(i, 1);
          setValues(values => ({
               ...values,
               products: products,
               selectedProducts: selectedProducts,
               searchResult: searchResult
          }));
     }

     function handleRemove(id, i) {
          let searchResult = values.searchResult;
          let selectedProducts = values.selectedProducts;
          selectedProducts[i].isCheck = !selectedProducts[i].isCheck;
          let selected = Object.assign({}, selectedProducts[i]);
          let products = values.products;
          products.splice(i,1);
          selectedProducts.splice(i,1);
          searchResult.push(selected);
          setValues(values => ({
               ...values,
               products: products,
               selectedProducts: selectedProducts,
               searchResult: searchResult
          }));
     }

     function handleSearchSubmit(e) {
          e.preventDefault();
          if(values.search != ''){
               setSending(true);
               axios.post(route('productprom.search'), {_token:data.token, search: values.search}).then((response) => {
                    setSending(false);
                    setValues(values => ({
                         ...values,
                         searchResult: response.data.products
                    }));
               });
          }
          return false;
     }

     function handleDelete(e, id, i){
          e.preventDefault();
          axios.post(route('productprom.remove', data.id), {_token:data.token, product: id}).then((result) => {
               if(result.data.data.deleted){
                    let prods = values.prods
                    prods.splice(i,1);
                    setValues(values => ({
                         ...values,
                         prods: prods
                    }));
               }
          }).catch((error) => {
               console.log(error);
          });
     }

     function handleSubmit(e) {
          e.preventDefault();
          setSending(true);
          Inertia.post(route('productprom.store', data.id), values).then(() => {
               setSending(false);
          });
     }

     return (
          <React.Fragment key="permission-c">
               <Helmet>
                    <title>Promotion</title>
               </Helmet>
               <ProfileCard>
                    <div className="md:col-span-1">
                         <div className="px-4 sm:px-0">
                              <h3 className="text-lg font-medium text-gray-900">Promotion</h3>
                              <p className="mt-1 text-sm text-gray-600">Name : <span className="float-right font-semibold">{data.name}</span></p>
                              <p className="mt-1 text-sm text-gray-600">Code : <span className="float-right font-semibold">{data.code}</span></p>
                              <p className="mt-1 text-sm text-gray-600">Discount : <span className="float-right font-semibold">{data.discount} %</span></p>
                              <p className="mt-1 text-sm text-gray-600">Period : <span className="float-right font-semibold">{moment(data.start).format('DD MMM YYYY')} - {moment(data.end).format('DD MMM YYYY')}</span></p>
                              <p className="mt-1 text-sm text-gray-600">Status : <span className="float-right font-semibold">{data.statusCaption}</span></p>
                              <h3 className="text-md font-medium text-gray-900 mt-4">Products</h3>
                              <ul className="overflow-auto h-64 list-none pt-2">
                                   {values.prods.map(({id, name, code}, i) => {
                                        return <li className={`p-2 mt-2 rounded bg-blue-100`} key={id}>
                                             <label className="flex items-center" htmlFor="perms">
                                                  <span className="text-sm font-semibold text-gray-800">{name}</span>
                                                  <button onClick={e=>handleDelete(e, id, i)} className="border border-red-600 rounded px-2 py-1">
                                                       <Icon name="trash" className={iconClassesTrash} />
                                                  </button>
                                             </label>
                                             <p className="text-xs text-gray-500">{code}</p>
                                        </li>
                                   })}
                              </ul>
                         </div>
                    </div>
                    <DataCard>
                         <div className="px-4 py-5 sm:p-6">
                              <div className="grid grid-cols-3 gap-3">
                                   <div className="col-span-12 text-right">
                                        <InertiaLink href={route('promotion.index')} className="bg-transparent border border-gray-500 text-sm text-gray-500 p-2 rounded focus:outline-none hover:bg-gray-600 hover:text-gray-100 inline-flex items-center">
                                             <Icon name="back" className={iconClasses} />
                                             Back
                                        </InertiaLink>
                                   </div>
                                   <form className="col-span-12" onSubmit={handleSearchSubmit}>
                                        <div className="flex col-span-12">
                                             <TextInput
                                                   className="form-input rounded-md shadow-sm mt-4 block w-3/4"
                                                   label="Searchs"
                                                   name="search"
                                                   type="text"
                                                   disable={false}
                                                   readonly={false}
                                                   must={true}
                                                   errors={errors.search}
                                                   value={values.search}
                                                   onChange={handleChange}
                                              />
                                             <LoadingButton type="submit" loading={sending} className="mt-8 inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray disabled:opacity-25 transition ease-in-out duration-150 ml-4">
                                                  Search
                                             </LoadingButton>
                                        </div>
                                   </form>
                                   {(values.searchResult.length > 0) && (<ul className="col-span-12 overflow-auto h-64 list-none pt-2 mt-2">
                                        {values.searchResult.map(({id, name, code, isCheck}, i) => {
                                             return <li className={`p-2 mt-2 rounded hover:bg-gray-200 hover:shadow-md`} key={id}>
                                                  <label className="flex items-center" htmlFor="perms">
                                                       <input name="prods[]" id="prods[]" className="form-checkbox" type="checkbox" value={id} checked={isCheck} onChange={e => handleAdd(id, i)}/>
                                                       <span className="ml-2 text-sm text-gray-800">{name}</span>
                                                  </label>
                                                  <p className="text-sm text-gray-500 pl-6">{code}</p>
                                             </li>
                                        })}
                                   </ul>)}
                                   {(values.selectedProducts.length > 0) && (<form className="col-span-12 bg-gray-100" onSubmit={handleSubmit}>
                                        <ul className="col-span-12 overflow-auto h-64 list-none pt-2 mt-2">
                                             {values.selectedProducts.map(({id, name, code, isCheck}, i) => {
                                                  return <li className={`p-2 mt-2 rounded hover:bg-gray-200 hover:shadow-md`} key={id}>
                                                       <label className="flex items-center" htmlFor="perms">
                                                            <input name="prods[]" id="prods[]" className="form-checkbox" type="checkbox" value={id} checked={isCheck} onChange={e => handleRemove(id, i)}/>
                                                            <span className="ml-2 text-sm text-gray-800">{name}</span>
                                                       </label>
                                                       <p className="text-sm text-gray-500 pl-6">{code}</p>
                                                  </li>
                                             })}
                                        </ul>
                                        <div className="flex items-center justify-end px-4 py-3 bg-gray-100 text-right sm:px-6 rounded-b">
                                             <LoadingButton type="submit" loading={sending} className="inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:shadow-outline-gray disabled:opacity-25 transition ease-in-out duration-150 ml-4">
                                                  Save
                                             </LoadingButton>
                                        </div>
                                   </form>)}
                              </div>
                         </div>
                    </DataCard>
               </ProfileCard>
          </React.Fragment>
     );
}

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
AssingProduct.layout = page => <AdminLayout children={page} header={'Create Promotion'} />;

export default AssingProduct;
